import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["lang", "aria-label"]

import { computed, onMounted, ref } from 'vue';
import { RouterLink, useRoute } from 'vue-router';
import { languageSuggestions } from '@/i18n/suggestions';
import { useStore } from '@/store';
import { preferredLanguage } from '@/helpers/i18n/policy';
import { rememberLanguage } from '@/helpers/i18n/preference';
import { localizedPath } from '@/router/paths';

const storageKey = '__language-suggestion-dismissed__';

export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageSuggestion',
  setup(__props) {

const route = useRoute();
const store = useStore();
const ready = ref(false);
const dismissed = ref<string[]>([]);
const preferred = computed(() => preferredLanguage(store.state.settings, navigator.languages));
const pair = computed(() => `${route.meta.lang}:${preferred.value}`);
const visible = computed(
  () =>
    ready.value &&
    route.meta.lang &&
    !route.meta.skipSiteMap &&
    (!route.meta.availableLocales || (route.meta.availableLocales as string[]).includes(preferred.value)) &&
    route.meta.lang !== preferred.value &&
    !dismissed.value.includes(pair.value),
);
const target = computed(() => ({
  path: localizedPath(route.path, preferred.value),
  query: route.query,
  hash: route.hash,
}));
const copy = computed(() => languageSuggestions[preferred.value]);

onMounted(() => {
  // Never bake a build machine's browser-language suggestion into public HTML.
  if ('__AVALON_PRERENDER__' in window) return;
  try {
    const value = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
    if (Array.isArray(value)) dismissed.value = value.filter((item) => typeof item === 'string');
  } catch {
    /* Session storage may be disabled. Dismissal still works in memory. */
  }
  ready.value = true;
});

function accept(event: MouseEvent) {
  if (event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
    rememberLanguage(preferred.value);
  }
}

function dismiss() {
  dismissed.value.push(pair.value);
  try {
    sessionStorage.setItem(storageKey, JSON.stringify(dismissed.value));
  } catch {
    /* Optional persistence. */
  }
}

return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(), _createElementBlock("aside", {
        key: 0,
        class: "language-suggestion",
        lang: preferred.value,
        "aria-label": copy.value.message
      }, [
        _createElementVNode("span", null, _toDisplayString(copy.value.message), 1),
        _createVNode(_unref(RouterLink), {
          to: target.value,
          onClick: accept
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(copy.value.action), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("button", {
          type: "button",
          onClick: dismiss
        }, _toDisplayString(copy.value.dismiss), 1)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})